import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDislike = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2 13C1.46667 13 1 12.8 0.6 12.4C0.2 12 0 11.5333 0 11V9C0 8.88333 0.0125 8.75833 0.0375 8.625C0.0625 8.49167 0.1 8.36667 0.15 8.25L3.15 1.2C3.3 0.866667 3.55 0.583333 3.9 0.35C4.25 0.116667 4.61667 0 5 0H13C13.55 0 14.0208 0.195833 14.4125 0.5875C14.8042 0.979167 15 1.45 15 2V12.175C15 12.4417 14.9458 12.6958 14.8375 12.9375C14.7292 13.1792 14.5833 13.3917 14.4 13.575L8.975 18.975C8.725 19.2083 8.42917 19.35 8.0875 19.4C7.74583 19.45 7.41667 19.3917 7.1 19.225C6.78333 19.0583 6.55417 18.825 6.4125 18.525C6.27083 18.225 6.24167 17.9167 6.325 17.6L7.45 13H2ZM19 0C19.55 0 20.0208 0.195833 20.4125 0.5875C20.8042 0.979167 21 1.45 21 2V11C21 11.55 20.8042 12.0208 20.4125 12.4125C20.0208 12.8042 19.55 13 19 13C18.45 13 17.9792 12.8042 17.5875 12.4125C17.1958 12.0208 17 11.55 17 11V2C17 1.45 17.1958 0.979167 17.5875 0.5875C17.9792 0.195833 18.45 0 19 0Z",
		fill: "#9B9B9B"
	})]
});
const ForwardRef = forwardRef(SvgDislike);
export { ForwardRef as ReactComponent };
